import { ISchool } from '../../interfaces/groups/school.interface';
import { IUser } from '../../interfaces/users/user.interface';

export class Login {
    public static readonly type = '[Auth] login';
    constructor(public payload: { email: string; password: string; rememberMe: boolean }) {}
}

export class Logout {
    public static readonly type = '[Auth] logout';
}

export class ResetPassword {
    public static readonly type = '[Password] reset';
    constructor(public email: string) {}
}

export class SetNewPwd {
    public static readonly type = '[Password] set new';
    constructor(public newPassword: string, public token: string) {}
}

export class CreatePwd {
    public static readonly type = '[Password] create new';
    constructor(public password: string, public token: string) {}
}

export class ResetFinalStepForgot {
    public static readonly type = '[Password] reset final step';
}

export class SetSelectedSchool {
    public static readonly type = '[Auth] school selected';
    constructor(public school: ISchool) {}
}

export class SetCurrentUser {
    public static readonly type = '[Auth] current user';
    constructor(public user: IUser) {}
}

export class GetMyUser {
    public static readonly type = '[Auth] Get My user';
}

export class RefreshTokens {
    public static readonly type = '[Auth] Refresh tokens';
}

export class ResetAuth {
    public static readonly type = '[Auth] Reset auth data';
}

export class PatchMyUser {
    public static readonly type = '[My user] patch';
    constructor(public myUser: IUser) {}
}

export class ResetSelectedSchool {
    public static readonly type = '[Selected school] reset';
}

export class SetRememberMe {
    public static readonly type = '[Remember me] set';
}

export class ResetRememberMe {
    public static readonly type = '[Remember me] reset';
}
